import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["text"];
import React, { memo, useMemo } from 'react';
import classNames from 'classnames';
import { createUseStyles, useTheme, Badge, Button, Icon, Text, Markdown } from 'hoi-poi-ui';
import { useWeb5Context } from "../../../lib/Web5Context";
import styles from "../styles/AddOnsCard";
const useStyles = createUseStyles(styles, 'AddOnsCard');
const AddOnsCard = _ref => {
  let {
    title,
    icon,
    disabled,
    info,
    badge,
    content,
    figure,
    onHover,
    itemCode,
    linkCallback
  } = _ref;
  const {
    t
  } = useWeb5Context();
  const classes = useStyles();
  const theme = useTheme();
  const rootProps = useMemo(() => ({
    className: classNames(classes.root, {
      [classes.hasInfo]: !!info
    }),
    onMouseEnter: () => onHover && onHover(itemCode)
  }), [classes.hasInfo, classes.root, info, itemCode, onHover]);
  const getIcon = useMemo(() => {
    switch (true) {
      case typeof icon === 'string':
        const iconProps = {
          name: icon,
          className: classes.icon,
          color: disabled ? theme.colors.utility.textDisabled : theme.colors.actionMajor[500],
          size: 'large'
        };
        return /*#__PURE__*/React.createElement(Icon, iconProps);
      case typeof icon === 'object' && !!(icon !== null && icon !== void 0 && icon.customIcon):
        return /*#__PURE__*/React.createElement("span", {
          className: classes.icon
        }, icon.customIcon);
      default:
        return null;
    }
  }, [classes.icon, disabled, icon, theme]);
  const getBadge = useMemo(() => {
    if (!badge) return null;
    const {
        text
      } = badge,
      badgeProps = _objectWithoutProperties(badge, _excluded);
    return /*#__PURE__*/React.createElement(Badge, _extends({
      className: classes.badge
    }, badgeProps), text);
  }, [badge, classes.badge]);
  const hoverContent = useMemo(() => {
    if (!info || typeof info !== 'object') return null;
    const {
      texts,
      cta
    } = info;
    return /*#__PURE__*/React.createElement("div", {
      className: classes.hoverContent
    }, texts && /*#__PURE__*/React.createElement(Markdown, {
      className: classes.hoverContentMarkdown,
      content: texts,
      overrides: {
        a: {
          target: '_blank'
        },
        p: {
          color: theme.colors.textLight.secondary
        }
      },
      linkCallback: linkCallback
    }), !!(cta !== null && cta !== void 0 && cta.length) && /*#__PURE__*/React.createElement("div", {
      className: classes.hoverContentCTA
    }, cta.map((button, index) => /*#__PURE__*/React.createElement(Button, {
      type: button.type,
      onClick: button.onClick,
      key: index
    }, button.text))));
  }, [classes.hoverContent, classes.hoverContentCTA, classes.hoverContentMarkdown, info, linkCallback, theme]);
  const Img = useMemo(() => figure === null || figure === void 0 ? void 0 : figure.img, [figure]);
  return /*#__PURE__*/React.createElement("div", rootProps, /*#__PURE__*/React.createElement("div", {
    className: classes.header
  }, getIcon, /*#__PURE__*/React.createElement(Text, {
    type: "h6",
    bold: true,
    color: theme.colors.textLight.primary
  }, title), getBadge), /*#__PURE__*/React.createElement("div", {
    className: classes.main
  }, content && /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, (content.price || content.noPriceInfo) && /*#__PURE__*/React.createElement("div", {
    className: classes.contentHeadline
  }, content.price && /*#__PURE__*/React.createElement(Text, {
    type: "caption",
    color: theme.colors.textLight.primary,
    className: classes.price
  }, t('label_addon_price_per_month', [content.price], text => /*#__PURE__*/React.createElement(Text, {
    type: "h6",
    color: theme.colors.textLight.primary
  }, text))), content.noPriceInfo && /*#__PURE__*/React.createElement(Markdown, {
    content: content.noPriceInfo,
    overrides: {
      p: {
        type: 'caption',
        color: theme.colors.textLight.primary
      }
    }
  })), content.description && /*#__PURE__*/React.createElement(Text, {
    type: "caption",
    color: theme.colors.textLight.secondary
  }, content.description)), figure && /*#__PURE__*/React.createElement("figure", {
    className: classes.figure
  }, Img && /*#__PURE__*/React.createElement(Img, null), figure.caption && /*#__PURE__*/React.createElement("figcaption", null, /*#__PURE__*/React.createElement(Text, {
    type: "badges"
  }, figure.caption)))), hoverContent);
};
export default /*#__PURE__*/memo(AddOnsCard);